import { drawing as d, geometry as g } from '@progress/kendo-drawing';
/**
 * @hidden
 */
export class TextLayout extends d.Layout {
    measure() {
        if (!this._rect || this.children.length === 0) {
            return new g.Size(0, 0);
        }
        this._initMap();
        const { groups, groupsSize } = this._initGroups();
        if (groups.length === 0) {
            return new g.Size(0, 0);
        }
        const { sizeField, groupsSizeField } = this._fieldMap;
        let maxSize = 0;
        for (let i = 0; i < groups.length; i++) {
            maxSize = Math.max(maxSize, groups[i].size);
        }
        const size = new g.Size();
        size[sizeField] = maxSize;
        size[groupsSizeField] = groupsSize;
        return size;
    }
    rawBBox() {
        if (!this._rect || this.children.length === 0) {
            return new g.Rect(this._rect.origin, new g.Size());
        }
        const size = this.measure();
        return new g.Rect(this._rect.origin, size);
    }
    bbox(transformation) {
        if (!this._rect || this.children.length === 0) {
            const emptyRect = new g.Rect(this._rect.origin, new g.Size());
            const transform = this.currentTransform(transformation);
            return transform ? emptyRect.bbox(transform.matrix()) : emptyRect;
        }
        const rawBox = this.rawBBox();
        const transform = this.currentTransform(transformation);
        return transform ? rawBox.bbox(transform.matrix()) : rawBox;
    }
}
